import { PageSummary, PagerButtons } from '@/features/cases/Pager'

export const AUDIT_PAGE_SIZES = [50, 100, 200] as const
export type AuditPageSize = (typeof AUDIT_PAGE_SIZES)[number]

/**
 * The bar under an audit table: "Showing 51–100 of 18,240 · page 2 of 365",
 * a rows-per-page choice and Prev / Next. The Audit log and the PII access
 * trail share it. While [loading], the rows on screen are still the previous
 * page's, so it says which page is coming instead of miscounting.
 */
export function AuditPager({
  page, setPage, pageSize, setPageSize, rowsOnPage, total, emptyLabel, loading,
}: {
  page: number
  setPage: (update: (p: number) => number) => void
  pageSize: AuditPageSize
  setPageSize: (size: AuditPageSize) => void
  rowsOnPage: number
  total: number | null
  emptyLabel: string
  loading: boolean
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-5 py-3">
      <span className="text-2xs uppercase tracking-wider text-muted-foreground">
        {loading ? (
          <>Loading page {page + 1}…</>
        ) : (
          <PageSummary page={page} rowsOnPage={rowsOnPage} total={total} pageSize={pageSize} emptyLabel={emptyLabel} />
        )}
      </span>
      <span className="inline-flex items-center gap-4">
        <label className="inline-flex items-center gap-2 text-2xs uppercase tracking-wider text-muted-foreground">
          Per page
          <select
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value) as AuditPageSize)}
            className="rounded-md border border-slate-200 bg-white px-2 py-1 text-xs text-navy-900 hover:border-navy-200"
          >
            {AUDIT_PAGE_SIZES.map((n) => (
              <option key={n} value={n}>{n}</option>
            ))}
          </select>
        </label>
        <span className={loading ? 'pointer-events-none inline-flex gap-4 opacity-50' : 'inline-flex gap-4'}>
          <PagerButtons page={page} setPage={setPage} rowsOnPage={rowsOnPage} total={total} pageSize={pageSize} />
        </span>
      </span>
    </div>
  )
}
